<template>
  <v-row no-gutters class="rowContent mt-0">
    <div
      class="textContent "
      ref="textContentBox"
    >
      <component v-bind:is="transformedContent"></component>
    </div>

    <v-btn
      v-if="isEllipsis"
      text
      plain
      @click="isEllipsis = !isEllipsis"
      class="pl-0 mb-4"
    >
      <translate class="primary--text body text-capitalize font-weight-bold"
        >See more</translate
      >
      <v-icon right dark color="primary" class="ml-1">
        far fa-angles-right
      </v-icon>
    </v-btn>
  </v-row>
</template>
<script>
export default {
  name: "PostContent",
  components: {},
  props: {
    content: { type: String, default: "" }
  },
  data() {
    return {
      heightContent: 0,
      isEllipsis: false
    };
  },
  computed: {
    htmlContent() {
      const regex = /<a\shref=\"([a-zA-Z0-9\-]+)gammarSplitter([a-zA-Z0-9\-]+)\">([^\<]+)<\/a>/g
      return this.content.replace(
        regex,
        '<router-link \
          :to="{\
            name: \'courses.home\',\
            params: {\
              coursesCountry: \'$1\',\
              namegolf: \'$2\',\
            },\
          }\
        ">$3</router-link>'
      ).replace(/\n/g, '<br>').replace(/<p>/g, '').replace(/<\/p>/g, '<br><br>')
    },
    transformedContent () {
      const template = `
      <div 
        :class="$parent.isEllipsis 
                ? 'ellipsis-5line' : 'mb-4'"
      >
        ${this.htmlContent}
      </div>`
      return {
        template
      }
    }
  },
  watch: {
    content() {
      this.$nextTick(() => {
        this.reset();
        this.showSeeMore();
      });
    }
  },
  mounted() {
    this.reset();
    this.showSeeMore();
  },
  methods: {
    showSeeMore() {
      this.heightContent = this.$refs.textContentBox.clientHeight;
      if (this.heightContent > 120) {
        this.isEllipsis = true;
      } else {
        this.isEllipsis = false;
      }
    },
    reset() {
      this.heightContent = 0;
      this.isEllipsis = false;
    }
  }
};
</script>
